import React from 'react';
import { Card, Typography, Divider, Statistic, Row, Col } from "antd";
import { t } from "i18next";
import Helper from "../../../core/Helper"; // Projenizdeki yol
import {
    MdAttachMoney,
    MdCheckCircleOutline,
    MdAccountBalanceWallet
} from "react-icons/md";
import { useUser } from "../../../core/context/UserContext";

const { Text } = Typography;

export default function PriceSummaryPreview({ totalPrice, totalPaid, currency = 'TRY' }) {
    const { formatPrice } = useUser();

    // Geçersiz veri kontrolü (Orijinal koddaki -1 mantığı)
    const isValid = totalPrice !== -1 && totalPaid !== -1;

    // Bakiye Hesabı
    const balance = isValid ? (totalPrice - totalPaid) : 0;

    // Borç var mı? (Renk değişimi için)
    const hasDebt = balance > 0;

    // Helper: Para formatlama (Statistic valueRender için)
    const formatMoney = (val) => formatPrice(val, { currency });

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Card
                size="small"
                bordered={true}
                style={{
                    width: '100%',
                    maxWidth: 350, // Masaüstünde çok genişlemesini engeller
                    borderRadius: 8,
                    borderColor: '#f0f0f0'
                }}
                bodyStyle={{ padding: '16px 24px' }}
            >
                {/* Başlık */}
                <Text type="secondary" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {t('Payment Summary')}
                </Text>

                <Divider style={{ margin: '12px 0' }} />

                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>

                    {/* Satır 1: Toplam Tutar */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#595959' }}>
                            <MdAttachMoney size={16} />
                            <Text style={{ fontSize: 14 }}>{t('Total Price')}</Text>
                        </div>
                        <Text strong style={{ fontSize: 15 }}>
                            {isValid ? formatMoney(totalPrice) : '-'}
                        </Text>
                    </div>

                    {/* Satır 2: Ödenen (Yeşil Vurgu) */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#389e0d' }}>
                            <MdCheckCircleOutline size={16} />
                            <Text style={{ fontSize: 14, color: '#595959' }}>{t('Total Paid')}</Text>
                        </div>
                        <Text strong style={{ color: '#389e0d', fontSize: 15 }}>
                            {isValid ? formatMoney(totalPaid) : '-'}
                        </Text>
                    </div>

                    {/* Ayırıcı Çizgi */}
                    <div style={{ borderTop: '2px dashed #f0f0f0', margin: '4px 0' }} />

                    {/* Satır 3: Bakiye (Büyük ve Renkli) */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <MdAccountBalanceWallet size={20} color={hasDebt ? '#cf1322' : '#389e0d'} />
                            <Text strong style={{ fontSize: 16, color: '#262626' }}>{t('Balance')}</Text>
                        </div>

                        <div style={{ textAlign: 'right' }}>
                            <Text strong style={{
                                fontSize: 20,
                                color: hasDebt ? '#cf1322' : '#389e0d' // Borç varsa Kırmızı, yoksa Yeşil
                            }}>
                                {isValid ? formatMoney(balance) : '-'}
                            </Text>
                            {hasDebt && (
                                <div style={{ fontSize: 11, color: '#cf1322', marginTop: -4 }}>
                                    {t('Unpaid')}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
}